import { render, staticRenderFns } from "./SlotPanel.vue?vue&type=template&id=5ebe1be6&scoped=true&"
import script from "./SlotPanel.vue?vue&type=script&lang=js&"
export * from "./SlotPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebe1be6",
  null
  
)

export default component.exports